import { useMemo } from 'react'

import { INCIDENT_CODE_INCORRECT_ADDRESS, INCIDENT_CODE_NO_ANSWER_RE, INCIDENT_CODE_NO_EFFECTIVE, INCIDENT_CODE_REFUSED } from '../../common/constants'
import useTranslations from '../../i18n/useTranslations'
import { INCIDENT_CODE_FILTER_ORDER } from './constants'

const INCIDENT_CODE_LABEL_MAP = {
  [INCIDENT_CODE_NO_ANSWER_RE]: 'tracking:no_answer',
  [INCIDENT_CODE_INCORRECT_ADDRESS]: 'tracking:incorrect_address',
  [INCIDENT_CODE_REFUSED]: 'tracking:refuses',
  [INCIDENT_CODE_NO_EFFECTIVE]: 'tracking:no_effective',
}

export const useIncidentCodeFilterOptions = isOptionChecked => {
  const t = useTranslations()

  return useMemo(
    () =>
    INCIDENT_CODE_FILTER_ORDER.map(incidentCode => ({
        id: incidentCode,
        label: t(INCIDENT_CODE_LABEL_MAP[incidentCode]),
        checked: isOptionChecked(incidentCode),
      })),
    [t, isOptionChecked],
  )
}